type Item = {
  phoneCode: string;
  iso1Code: string;
};

const getISOCodeByCode = (
  items: Item[] = [],
  value: string = ''
): string | undefined => items.find((i) => i.phoneCode === value)?.iso1Code;

export default getISOCodeByCode;
